import Apis from 'apis';

export const api = Apis({
  baseURL: process.env.REACT_APP_URL || '',
});

export default {
  disconnectUser: () => `disconnect_user`,
};
